import gql from 'graphql-tag';

export const createFreedomPayAccount = gql`
	mutation createFreedomPayAccount($input: FreedomPayAccountInput) {
		createFreedomPayAccount(input: $input) {
			uuid
			tenantId
			tenantName
		}
	}
`;
